import { gql } from "graphql-tag";

import { getSeoFields, getMetaFields } from "~/mixins/seoMixin";

const PAGE_TYPE = "Blogpage";

const QUERY_BLOG_PAGE = gql`
  query blogpage($uid: String!, $lang: String = "en-in") {
    ${PAGE_TYPE}:blogpage(uid: $uid, lang:$lang) {
      title
      ...${PAGE_TYPE}SEOFields
      ...${PAGE_TYPE}MetaFields
    }
  }
  ${getSeoFields(PAGE_TYPE)}
  ${getMetaFields(PAGE_TYPE)}
`;

export { PAGE_TYPE, QUERY_BLOG_PAGE };
